export default {
  en: {
    policyLinks: [{ title: 'Privacy Policy', link: '/privacy-policy' }],
  },
  es: {
    policyLinks: [{ title: 'Política de Privacidad', link: '/es/politica-de-privacidad' }],
  },
  pt: {
    policyLinks: [{ title: 'Política de privacidade', link: '/br/politica-de-privacidade' }],
  },
};
